import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import StockAIRoutes from './StockAIRoutes';

export default function StockAIEntry() {
  return (
    <Router basename="/stockai">
      <StockAIRoutes />
    </Router>
  );
}